export const map = (map) => {


  //Elements used for filtering the map
  const btnFilterMap = '.js-filter-map';
  const current = '.js-filter-current';
  const list = '.js-filters';

  //Elements used on interaction with map
  const locationTitle = $('.js-location-title');
  const filterTitle = $('.js-filter-current');

  //Colours used for map styling
  const backgroundColour = $('body').attr('data-colour-background');
  const labelsColour = $('body').attr('data-colour-text');

  //Colours used for markers
  const pinColour = $('body').attr('data-colour-text');
  const pinHoverStateColour =  $('body').attr('data-colour-text-hoverstate');


  const init = () => {
      
      let Styled = [{
        "featureType": "administrative",
        "elementType": "labels",
        "stylers": [{
          "visibility": "on"
        }]
      },
      {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": labelsColour
        }]
      },
      {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [{
          "color": backgroundColour
        }]
      },
      {
        "featureType": "landscape",
        "elementType": "labels",
        "stylers": [{
          "visibility": "on"
        }]
      },
      {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [{
          "visibility": "off"
        }]
      },
      {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [{
          "visibility": "off"
        }]
      },
      {
        "featureType": "road",
        "elementType": "all",
        "stylers": [{
            "color": labelsColour
          },
          {
            "weight": "0.1"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [{
          "visibility": "off"
        }]
      },
      {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [{
            "color": labelsColour
          },
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.text.stroke",
        "stylers": [{
            "color": backgroundColour
          },
          {
            "visibility": "on"
          },
          {
            "weight": "2.00"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [{
            "visibility": "on"
          },
          {
            "weight": "0.5"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [{
          "weight": "0.2"
        }]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels",
        "stylers": [{
          "visibility": "off"
        }]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels",
        "stylers": [{
          "visibility": "on"
        }]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [{
          "visibility": "off"
        }]
      },
      {
        "featureType": "road.local",
        "elementType": "all",
        "stylers": [{
          "visibility": "on"
        }]
      },
      {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [{
          "visibility": "off"
        }]
      },
      {
        "featureType": "transit",
        "elementType": "labels",
        "stylers": [{
          "visibility": "simplified"
        }]
      },
      {
        "featureType": "transit",
        "elementType": "labels.icon",
        "stylers": [{
          "visibility": "off"
        }]
      },
      {
        "featureType": "water",
        "elementType": "all",
        "stylers": [{
            "color": "#b7b7b7"
          },
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [{
            "visibility": "on"
          },
          {
            "color": labelsColour
          }
        ]
      }
    ];

    let myLatLng = {lat: 51.219, lng: 4.402};
  	let options = {
  		zoom: 14,
      center: myLatLng,
  		disableDefaultUI: true,
  		scrollwheel: false,
  		navigationControl: false,
      zoomControl: true,
      zoomControlOptions: {
          style: google.maps.ZoomControlStyle.SMALL,
          position: google.maps.ControlPosition.RIGHT_TOP
      },
      scaleControl: true,
      scrollwheel: false,
      fontSize: "8px",
      label: {
        fontSize: "8px"
      },
      backgroundColor: backgroundColour,
  		mapTypeId: 'Styled'
    };

  	let map = new google.maps.Map(document.getElementById('map'), options);
  	let styledMapType = new google.maps.StyledMapType(Styled, { name: 'Styled' });

    let markers = [];

  	map.mapTypes.set('Styled', styledMapType);

    let svgMarker = {
      path: google.maps.SymbolPath.CIRCLE,
      scale: 11,
      fillColor: pinColour,
      fillOpacity: 1,
      strokeColor: backgroundColour,
      strokeWeight:1,
      size: new google.maps.Size(22, 22), 
      scaledSize: new google.maps.Size(22, 22)
    };

    let svgMarkerHover = {
      path: google.maps.SymbolPath.CIRCLE,
      scale: 11,
      fillColor: pinHoverStateColour,
      fillOpacity: 1,
      strokeColor: backgroundColour,
      strokeWeight:1,
      size: new google.maps.Size(22, 22), 
      scaledSize: new google.maps.Size(22, 22)
    };

    // Adds a marker to the map and push to the array.
    function addMarker(location) {

      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(location.lat, location.lon),
        // icon: icons['location'].icon,
        icon: svgMarker,
        map: map,
        title: location.title,
        url: location.url,
        categories: location.categories
      });

      markers.push(marker);

      google.maps.event.addListener(marker, 'click', function() {
        window.location.href = marker.url;
      });

      google.maps.event.addListener(marker, 'mouseover', function() {
        filterTitle.addClass('u-hidden');
        locationTitle.removeClass('u-hidden');
        locationTitle.text(marker.title);
        marker.setIcon(svgMarkerHover);
      });

      google.maps.event.addListener(marker, 'mouseout', function() {
        filterTitle.removeClass('u-hidden');
        locationTitle.addClass('u-hidden');
        marker.setIcon(svgMarker);

      });

    }

    // Sets the map on all markers in the array.
    function setMapOnAll(map) {
      for (let i = 0; i < markers.length; i++) {
        markers[i].setMap(map);
      }
    }

    function filterMarkers(category) {  
      // console.log(category);
      for (let i = 0; i < markers.length; i++) {
        // console.log(markers[i].categories);
        if (markers[i].categories.match(category)) { 
          console.log("category is " + markers[i].categories); 
          markers[i].setVisible(true);
        }
        else { 
          markers[i].setVisible(false);
        }
      }
    }

    // Removes the markers from the map, but keeps them in the array.
    function clearMarkers() {
      setMapOnAll(null);
    }

    // Shows any markers currently in the array.
    function showMarkers() {
      setMapOnAll(map);
    }

    function collectLocationData() {

      $.ajax({
        url:'map.json',
        dataType: 'json',
        success: function(location){
          $.each(location, function(key, location) {
            addMarker(location);
          });
        }
      });

    }

    function applyFilter(filter) {
   
      $.ajax({
        url:'map.json' + '?category=' + filter,
        dataType: 'json',
        success: function(location){
          clearMarkers();
          $.each(location, function(key, location) {
            addMarker(location);
          });
        }
      });

    }


    $(btnFilterMap).on('click', function(e) {
      e.preventDefault();
    
      //Removing class is-current from current filter, in order to show it again in the list.
      $(btnFilterMap).removeClass('is-current');
      //Add is-current class to the clicked filter to hide it from the list.
      $(this).addClass('is-current');
      //Then replace text of filter toggle with current filter text.
      $(current).text($(this).text());
      //Close the filters list
      $(list).attr('data-state', $(list).attr('data-state') =='closed' ? 'open' : 'closed');

      //Do the filtering
   
      let category = $(this).attr('data-category');
      filterMarkers(category);
      // let categories = $(this).attr('data-category');
      // if(categories == '' || categories == 'all') {
      //   showMarkers();
      // } else {
      //   // clearMarkers();
      //   applyFilter($(this).attr('data-category'));
      // }

    });

    collectLocationData();

  };

  if ($(map).length > 0) {
    init();
  }

};